import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
    Container,
    Card,
    Row,
    Col,
    Button,
    Form, FloatingLabel
} from "react-bootstrap";

import Table from "../../../components/Table";
import ConfirmModal from "../../../components/ConfirmModal";
import { getServiceRequest, updateServiceRequest } from "../../../commons/ServiceRequest";
import { useAlert } from "../../../context/AlertContext";
import ButtonOptionSubmenu from "../../../components/ButtonOptionSubmenu";
import AssetService from "../../../services/asset.service";
import CardDisplayComponent from "../../../components/CardDisplayComponent";
import { useNavigate, useParams } from "react-router-dom";


export default function ReturnPropertyInstallationWorkOrderDetail() {
    const navigate = useNavigate();
    const { id } = useParams();
    const { showAlert } = useAlert();

    const [showModal, setShowModal] = useState(false);

    const [loading, setLoading] = useState(false);
    const [assetCodeDD, setassetCodeDD] = useState([]);

    const [searchValue, setSearchValue] = useState([]);
    const [data, setData] = useState([]);

    const columns = [
        {
            name: "รหัสทรัพย์สิน",
            selector: 'Asset_Code',
            width: "250px"
        },
        {
            name: "ชื่อทรัพย์สิน",
            selector: 'Asset_Name',
            width: "500px"
        },

        {
            name: "สถานะทรัพย์สิน",
            selector: 'Asset_Status',
            width: "300px"
        },
    ]


    useEffect(() => {
        getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: AssetService.getAssetReturnsById(id),
            callback: (res) => {
                setData(res)
                setSearchValue([res])
            }
        });
    }, []);


    const handleSubmit = (event, { dataCallback, showCallback }) => {
        event.preventDefault();
        setShowModal(showCallback);

        updateServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: AssetService.updateStatus(id, { "Asset_Status": data.informInstallItem.Asset_Status }),
            callback: (res) => {

                if (res) {
                    getServiceRequest({
                        showAlert,
                        setLoading,
                        serviceRequest: AssetService.getAssetReturnsById(id),
                        callback: (res) => {
                            setData(res)
                            setSearchValue([res])
                        }
                    });
                }

            }
        });
    };




    return (
        <>
            <Helmet>
                <title>แก้ไขการคืนทรัพย์สิน</title>
                <meta
                    name="description"
                    content="Return Property an Installation Work Order Page"
                />
            </Helmet>

            <Container fluid className="p-0">


                <CardDisplayComponent
                    header={{ title: { text: "รายละเอียดทรัพย์สิน" } }}
                    body={{
                        element: (
                            <Card className="w-100 bg-transparent border-0">
                                <Card.Header className="p-0 bg-transparent hQPXLq rdt_TableHead">
                                    <Row
                                        className="mx-0 flex-nowrap border-bottom-0 gocYik rdt_TableHeadRow"
                                        style={{
                                            width: columns.length > 10 ? "max-content" : "100%",
                                            height: "53px"
                                        }}
                                    >
                                        {columns.map((col, idx) => (
                                            <Col
                                                key={idx}
                                                xs={columns.length > 10 ? 2 : (!col.name || col.width) && 1}
                                                className={`${columns.length > 10 && "w-auto"
                                                    } px-3 d-flex align-items-center fs-4 fw-bold text-truncate`}
                                                style={{
                                                    minWidth: col.minWidth,
                                                    width: col.name ? col.width : "0px"
                                                }}
                                            >
                                                {col.name}
                                            </Col>
                                        ))}
                                    </Row>
                                    <Row
                                        className="h-100 my-3 mx-0 flex-nowrap border-bottom-0 gocYik rdt_TableHeadRow"
                                        style={{
                                            width: columns.length > 10 ? "max-content" : "100%",
                                            height: "53px"
                                        }}
                                    >
                                        <Col
                                            className="px-3 d-flex align-items-center fs-4 fw-bold text-truncate"
                                            xs={1}
                                            style={{
                                                width: '250px'
                                            }}
                                        >
                                            {data?.Asset_Code}
                                        </Col>
                                        <Col
                                            className="px-3 d-flex align-items-center fs-4 fw-bold"
                                            xs={2}
                                            style={{
                                                width: '500px',
                                                maxWidth: '500px'
                                            }}
                                        >
                                            {data?.Asset_Name}
                                        </Col>
                                        <Col
                                            className="px-3 d-flex align-items-center fs-4 fw-bold text-truncate"
                                            style={{
                                                width: '300px'
                                            }}
                                        >
                                            {/* {data[0]?.Asset_Status} */}
                                            <FloatingLabel key={name} label={''} className="mb-3 fs-4">
                                                <Form.Control
                                                    required
                                                    type={'Asset_Status'}
                                                    className="p-3"
                                                    placeholder="โปรดระบุ"
                                                    onChange={({ target }) => {
                                                        setData((prev) => ({
                                                            ...prev,
                                                            informInstallItem: { ...prev.informInstallItem, Asset_Status: target.value }
                                                        }));
                                                    }}
                                                    value={data?.informInstallItem?.Asset_Status}
                                                />
                                            </FloatingLabel>

                                        </Col>
                                    </Row>
                                    <div className="pb-5 d-flex justify-content-end">
                                        <Button
                                            type="submit"
                                            variant="success"
                                            className="text-dark rounded-pill fs-4"
                                            style={{
                                                width: "250px",

                                            }}
                                            onClick={() => setShowModal(true)}
                                        >
                                            บันทึกข้อมูล
                                        </Button>
                                        <ConfirmModal
                                            show={showModal}
                                            data={data}
                                            content={"save"}
                                            onSubmitCallback={handleSubmit}
                                        />
                                    </div>
                                </Card.Header>
                            </Card>
                        )
                    }}
                />

            </Container>
        </>
    );
}
